import React, { useContext, useMemo, useState } from "react";
import { Box, IconButton, Typography, Dialog } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import FiberNewIcon from "@mui/icons-material/FiberNew";

import { AuthContext } from "../context";

const FileItem = ({ index, fileInfo, handleRemoveFile, props, maxWidth }) => {
	const authContext = useContext(AuthContext);
	const [isDialogOpen, setDialogOpen] = useState(false); // Stato per il dialogo

	const handleImageClick = () => {
		setDialogOpen(true); // Mostra il dialogo
	};

	const handleDialogClose = () => {
		setDialogOpen(false); // Chiudi il dialogo
	};

	const filePreview = useMemo(() => {
		if (
			fileInfo?.file?.type?.startsWith("image/") ||
			props?.imageExtensions.includes(fileInfo?.extension)
		) {
			return (
				<img
					src={
						fileInfo?.file?.imageData
							? URL.createObjectURL(fileInfo?.file?.imageData)
							: fileInfo?.file_url
					}
					alt="File preview"
					style={{
						width: "200px", // Larghezza uniforme
						height: "200px", // Altezza uniforme
						objectFit: "contain", // Ritaglia proporzionalmente
						border: "1px solid #ccc", // Bordo opzionale
						borderRadius: "4px", // Angoli arrotondati opzionali
					}}
					onClick={handleImageClick}
				/>
			);
		}
		return null;
	}, [fileInfo]);

	console.log("fileInfo", fileInfo);
	const inputFields = useMemo(() => {
		return props?.inputFields.map((field) => (
			<Box key={field.name} sx={{ flex: "1 1 200px", mr: 4 }}>
				{props.renderInput(field, fileInfo, index)}
			</Box>
		));
	}, [props.inputFields, fileInfo, index, props]);

	const fileName = useMemo(() => fileInfo?.name, [fileInfo]);

	return (
		<Box
			key={index}
			sx={{
				mb: 2,
				p: 2,
				display: "flex",
				flexDirection: "row",
				alignItems: "flex-start", // Allinea tutto in alto
				flexWrap: "nowrap",
				overflowX: "auto", // Mostra lo scroll solo quando necessario
				backgroundColor: "#f5f5f5",
				borderRadius: 1,
				boxShadow: 1,
				width: "100%",
				maxWidth: maxWidth || "100%", // Gestisci maxWidth se specificato
				whiteSpace: "nowrap", // Evita che gli elementi vadano su più righe
				marginBottom: "25px",
			}}
		>
			{/* Sezione superiore: pulsanti e anteprima */}
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					alignItems: "flex-start",
					flex: "0 0 auto", // Assicura che questa sezione non si ridimensioni
					mr: 3, // Spaziatura rispetto alla griglia
				}}
			>
				{/* Pulsanti */}

				<Box
					sx={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center", // Allinea i pulsanti al centro verticalmente
						mb: 2, // Spaziatura sotto i pulsanti
					}}
				>
					{!fileInfo?.file?.imageData ? (
						<IconButton
							size="large"
							sx={{ color: "black" }}
							onClick={() => window.open(fileInfo?.file_url)}
						>
							<DownloadIcon />
						</IconButton>
					) : (
						<IconButton size="large">
							<FiberNewIcon
								sx={{ color: "green", transform: "scale(1.8)" }}
							/>
						</IconButton>
					)}
					{authContext?.hasAuth(`DELETE_${props?.authModelName}`) && (
						<IconButton
							size="large"
							sx={{ color: "red", ml: 1 }} // Spaziatura tra i pulsanti
							onClick={() => {
								if (
									window.confirm(
										"Sei sicuro di voler rimuovere questo file?\n Attenzione questa operazione è irreversibile."
									)
								) {
									handleRemoveFile(index);
								}
							}}
						>
							<CloseIcon />
						</IconButton>
					)}
				</Box>

				{/* Nome file e anteprima */}
				<Typography
					variant="h6"
					gutterBottom
					sx={{
						maxWidth: "200px", // Limita la larghezza del nome file
						overflow: "hidden", // Nascondi testo in eccesso
						textOverflow: "ellipsis", // Aggiungi "..." per testo troncato
						whiteSpace: "nowrap", // Mantieni il testo su una sola riga
					}}
				>
					{fileInfo?.file?.name}
				</Typography>
				{filePreview}
			</Box>

			{/* Griglia degli input */}
			<Box
				sx={{
					display: "grid",
					gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", // Colonne dinamiche
					gap: 2, // Spaziatura tra righe e colonne
					alignItems: "start", // Allinea i contenuti in alto
					flex: "1 1 auto", // Permette alla griglia di riempire lo spazio disponibile
				}}
			>
				{inputFields}
			</Box>
			<Dialog open={isDialogOpen} onClose={handleDialogClose} fullWidth>
				<Box
					sx={{
						position: "relative",
						backgroundColor: "black",
					}}
				>
					<IconButton
						onClick={handleDialogClose}
						sx={{
							position: "absolute",
							top: 10,
							right: 10,
							zIndex: 10,
							backgroundColor: "white!important",
							borderRadius: "50%",
							width: 40,
							height: 40,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<CloseIcon color={"error"} />
					</IconButton>
					<img
						src={
							fileInfo?.file?.imageData
								? URL.createObjectURL(fileInfo?.file?.imageData)
								: fileInfo?.file_url
						}
						alt="File preview fullscreen"
						style={{
							width: "100%",
							height: "auto",
							display: "block",
							margin: "0 auto",
							objectFit: "fit",
						}}
					/>
				</Box>
			</Dialog>
		</Box>
	);
};

export default React.memo(FileItem);
